import Vue from 'vue';
import defaultPage from '@/components/help_center/empty.vue';

const state = {
  component: defaultPage,
  components: {
    dynforms: () => Vue.component('dynforms', () => import(/* webpackChunkName: "dynforms" */ '@/components/help_center/dynforms_help.vue')),

  },
  visibility: false,
  closable: true,
  destroyOnClose: true,
  footer: true,
};

const mutations = {
  component(state, component) {
    state.component = (typeof component === 'function') ? component : defaultPage;
  },
  visibility(state, value) {
    state.visibility = value;
  },
  closeable(state, value) {
    state.closable = value;
  },
  destroyOnClose(state, value) {
    state.destroyOnClose = value;
  },
  footer(state, value) {
    state.footer = value;
  },
};

const actions = {
  show({ commit }, page) {
    if (!state.visibility) {
      commit('component', state.components[page]);
      commit('visibility', true);
    }
  },
  hide({ commit }) {
    if (state.visibility) {
      commit('component', defaultPage);
      commit('visibility', false);
    }
  },
  toggle({ dispatch }) {
    if (!state.visibility) dispatch('show', state.component);
    else dispatch('hide');
  },
};

const getters = {
  component: state => state.component,
  visibility: state => state.visibility,
  closeable: state => state.closeable,
  destroyOnClose: state => state.destroyOnClose,
  footer: state => state.footer,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
